import { commonActions } from '../app/actions';

export const setLanguage = (language) => (dispatch) => {
  const { setValue } = commonActions('language');
  return dispatch(setValue(language));
};
